// extracted by mini-css-extract-plugin
export default {"wireless":"index_wireless_p7Lxv","link":"index_link_8aKoY","list":"index_list_IWPoq clearfix"};